/* eslint-disable */
// 定义项目内的表名
const featuresFeaturesItemList = "features/item-list"; // 功能模板1表名
const featuresFeaturesItemListAll = "singleTableTabPage/item-list-all"; // 功能模板2所有表名
const featuresFeaturesItemListOpened = "singleTableTabPage/item-list-opened"; // 功能模板2已启用表名
const featuresFeaturesItemListClosed = "singleTableTabPage/item-list-closed"; // 功能模板2已禁用表名
const listqueryList = "listQuery/item-list"; // 增删改查表名
const peoplemanageItemListAll = "peoplemanage/item-list-all"; // 人员信息全部表名
const peoplemanageItemListOnjob = "peoplemanage/item-list-onthejob"; // 人员信息在职在岗表名
const peoplemanageItemListleavejob = "peoplemanage/item-list-leavejob"; // 人员信息在职离岗表名
const peoplemanageItemListOnbutleave = "peoplemanage/item-list-onjobbutleave"; // 人员信息离职离岗表名
const featuresTemplateNavTable1 = "features-template/nav-table1"; // 应用导航表名
const inquiryCollect = "inquiry/inquiry-collect"; // 询价定投统计表
const peoplemanageSingleTab = "list-query/peoplemanageSingleTab"; // 主子表增删改查
const contractmaterialsList = "example-auto/demouser"; // 代码生成单表
const demouserList = "example-auto/demouserList"; // 代码生成单表主子表

const incomeRecognitionList = "/financialManagement/incomeRecognition"; // 收入确认

const purchaseContractInputAll =
  "/contractManagement/purchaseContractInput/all"; //采购合同录入全部
const purchaseContractInputPending =
  "/contractManagement/purchaseContractInput/pending"; //采购合同录入待提交
const purchaseContractList = "/contractManagement/purchaseContractList/index"; // 采购合同台账列表
const purchaseContractList_cargoList =
  "/contractManagement/purchaseContractList/cargoList"; // 采购合同台账列表-货物清单
const purchaseContractList_usingRange =
  "/contractManagement/views/purContract/contractDetails/usingRange"; // 采购合同台账列表-适用范围
const purchaseContractInputApproval =
  "/contractManagement/purchaseContractInput/approval"; //采购合同录入审批中
const purchaseContractInputReturn =
  "/contractManagement/purchaseContractInput/return"; //采购合同录入退回

const salesContractFinancialApprovalAll =
  "/contractManagement/views/salesContract/salesContractApproval/all"; // 销售合同审批全部
const salesContractFinancialApprovalPending =
  "/contractManagement/views/salesContract/salesContractApproval/pending"; // 销售合同审批待审批
const salesContractFinancialApprovalPass =
  "/contractManagement/views/salesContract/salesContractApproval/pass"; // 销售合同已审批全部
const salecContractList = "/contractManagement/salesContractList/index"; // 销售合同台账列表
const salecContractList_cargoList =
  "/contractManagement/salesContractList/cargoList"; // 销售合同台账列表-货物清单
const salecContractList_usingRange =
  "/contractManagement/views/salesContract/contractDetails/usingRange"; // 销售合同台账列表-适用范围
const purchaseContractFinancialApprovalAll =
  "/contractManagement/views/purContract/purContractApproval/all"; // 采购合同审批全部
const purchaseContractFinancialApprovalPending =
  "/contractManagement/views/purContract/purContractApproval/pending"; // 采购合同审批待审批
const purchaseContractFinancialApprovalPass =
  "/contractManagement/views/purContract/purContractApproval/pass"; // 采购合同已审批全部

const purchaseContractFinancialContractEffectAll =
  "contractManagement/views/purContract/contractEffect/all"; // 采购合同生效全部
const purchaseContractFinancialContractEffectPending =
  "contractManagement/views/purContract/contractEffect/pending"; // 采购合同生效待生效
const purchaseContractFinancialContractEffectApproval =
  "contractManagement/views/purContract/contractEffect/approval"; // 采购合同生效已生效

const purchaseOrderSearchAll = "orderManagement/purchaseOrderSearch/all";
const salesOrderSearchAll = "orderManagement/salesOrderSearchAll/all";

const supplierInputList = "/supplierManagement/supplierInput/list"; // 供应商维护-列表
const businessList = "businessList";

const calibrateAll = "calibrateAll";
const inquiryPublish = "inquiryPublish";
const inquiryToBePublish = "inquiryToBePublish";
const quotationAll = "quotationAll";
const requirementsConfirmed = "requirementsConfirmed";
const requirementsQuoted = "requirementsQuoted";
const requirementsReturned = "requirementsReturned";
const requirementsToBeConfirmed = "requirementsToBeConfirmed";
const inventoryInbound = "inventoryInbound";
const salesOutOrder = 'systemForm/self-operated-business/sales-out-order.vue'
const receiptManagementWaitSubmit = 'settlementManagement/views/invoiceManagement/receipt-management/wait-submit'
const receiptManagementInApproval = 'settlementManagement/views/invoiceManagement/receipt-management/in-approval'
const receiptManagementApprovalReturned = 'settlementManagement/views/invoiceManagement/receipt-management/approval-returned'
const receiptManagementSignedSealed = 'settlementManagement/views/invoiceManagement/receipt-management/signed-sealed'
const receiptManagementBeenInvalid = 'settlementManagement/views/invoiceManagement/receipt-management/been-invalid'

const projectScheduleList = '/productionManage/projectSchedule/all'
const fundingPlanList = '/financeManage/fundingPlan/all'

const tableList = {
  receiptManagementWaitSubmit,
  receiptManagementInApproval,
  receiptManagementApprovalReturned,
  receiptManagementSignedSealed,
  receiptManagementBeenInvalid,
  inventoryInbound,
  salesOutOrder,
  featuresFeaturesItemList,
  featuresFeaturesItemListAll,
  featuresFeaturesItemListOpened,
  featuresFeaturesItemListClosed,
  listqueryList,
  demouserList,
  peoplemanageItemListAll,
  peoplemanageItemListOnjob,
  peoplemanageItemListleavejob,
  peoplemanageItemListOnbutleave,
  featuresTemplateNavTable1,
  inquiryCollect,
  contractmaterialsList,
  peoplemanageSingleTab,

  incomeRecognitionList,
  purchaseContractInputAll,
  purchaseContractInputPending,
  purchaseContractInputApproval,
  purchaseContractInputReturn,
  salecContractList,
  salecContractList_cargoList,
  salecContractList_usingRange,
  purchaseContractList,
  purchaseContractList_cargoList,
  purchaseContractList_usingRange,

  salesContractFinancialApprovalAll,
  salesContractFinancialApprovalPending,
  salesContractFinancialApprovalPass,

  purchaseContractFinancialApprovalAll,
  purchaseContractFinancialApprovalPending,
  purchaseContractFinancialApprovalPass,

  purchaseContractFinancialContractEffectAll,
  purchaseContractFinancialContractEffectPending,
  purchaseContractFinancialContractEffectApproval,

  purchaseOrderSearchAll,
  salesOrderSearchAll,

  supplierInputList,
  businessList,

  calibrateAll,
  inquiryPublish,
  inquiryToBePublish,
  quotationAll,
  requirementsConfirmed,
  requirementsQuoted,
  requirementsReturned,
  requirementsToBeConfirmed,

  projectScheduleList,
  fundingPlanList
}
export default tableList;
